<template>
  <div>
    <div v-if="info">
      <div v-if="info.linkedPage" class="loadPage">
        <Page
          :id="info.linkInfo.pageId"
          :locale="locale"
          :lang="lang"
          :responsive="responsive"
          :translateType="translateType"
          :isPublic="isPublic"
          :roomKey="roomKey" />
      </div>
      <div class="reservation">
        <h1 class="boxTitle mb5 notranslate toUppercase">{{locale.do_reservation}}</h1>
        <!-- disabled -->
        <div v-if="info.disabled">
          <p class="formTitle">{{info.name[lang]}}</p>
          <div class="formGroup isRequired mb15">
            <p class="noData toCapitalize notranslate">{{locale.message_reservation_disabled}}</p>
          </div>
        </div>
        <!-- //disabled -->
        <ReservationForm
          :locale="locale"
          :lang="lang"
          :ln="ln"
          :info="info"
          :roomKey="roomKey"
          :isPublic="isPublic"
          @init="init" />
      </div>
    </div>
    <p v-else class="noReservationData notranslate">{{locale.data_loading}}</p>
  </div>
</template>

<script>
import moment from 'moment/moment'
import ReservationForm from '@/components/Reservation/Form.vue'
import Page from '@/views/Page.vue'

export default {
  name: 'Reservation',
  props: [
    'lang',
    'ln',
    'locale',
    'roomKey',
    'isPublic',
    'responsive',
    'translateType',
    'reservationId'
  ],
  components: {
    ReservationForm,
    Page
  },
  computed: {
  },
  watch: {
    '$route' (to, from, next) {
      if (to.params.reservationId !== from.params.reservationId) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    this.wsClose = true
    this.onClose()
  },
  created () {
    this.init()
    this.wsConnect()
  },
  data () {
    return {
      info: null,
      wsStatus: null,
      wsClose: false
    }
  },
  methods: {
    wsConnect () {
      if (this.socket === undefined || this.socket.readyState === 3) {
        this.socket = new WebSocket(process.env.VUE_APP_WS_RESERVATION)
        this.socket.onopen = (e) => {
          this.onOpen(e)
        }
        this.socket.onclose = (e) => {
          this.onClose(e)
        }
        this.socket.onmessage = (e) => {
          this.onMessage(e)
        }
        this.socket.onerror = (e) => {
          this.onError(e)
        }
      }
    },
    onOpen (e) {
      const data = {
        action: 'sendmessage',
        data: {
          cmd: 'reservation',
          siteid: this.$store.getters['authentication/getAuthInfo'].site,
          property: this.reservationId
        }
      }
      this.wsStatus = 'start'
      this.sendData(JSON.stringify(data))
    },
    sendData (data) {
      this.wsStatus = 'send'
      this.socket.send(data)
    },
    onMessage (e) {
      const res = JSON.parse(e.data)
      this.wsStatus = 'message'
      if (res.cmd && res.cmd.includes('update')) {
        // 예약내용이 변경되어 새로 불러옵니다.
        alert(this.locale.alert_reservation_update)
        this.init()
      }
    },
    onClose () {
      this.socket.close()
      if (!this.wsClose) {
        setTimeout(() => {
          this.wsConnect()
        }, 3000)
      }
    },
    onError (e) {
      this.wsStatus = 'error'
      setTimeout(() => {
        this.wsConnect()
      }, 3000)
    },
    track (title) {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    init () {
      const reservationId = this.reservationId
      function getHhmm (string) {
        const hh = string.substr(0, 2)
        const mm = string.substr(2, 2)
        return moment().set({ hour: hh, minute: mm }).toISOString()
      }
      function getTime (arr) {
        const result = arr.map(x => {
          return {
            from: getHhmm(x.from),
            to: getHhmm(x.to),
            timeId: `${x.from}${x.to}`,
            name: `${moment(getHhmm(x.from)).format('HH:mm')} ~ ${moment(getHhmm(x.to)).format('HH:mm')}`,
            label: x.label
          }
        })
        return result
      }
      function getPositionX (index, listWidth, w, h) {
        const itemX = parseInt(listWidth / w)
        return parseInt(index % itemX) * w
      }
      function getPositionY (index, listWidth, w, h) {
        const itemX = parseInt(listWidth / w)
        return parseInt(index / itemX) * h
      }
      function seatMapInit (section, seatMap) {
        const places = section.place
        const w = 100
        const h = 100
        const listWidth = 600
        const colors = [
          '#ed5564',
          '#eda605',
          '#68b11b',
          '#4fa8e8',
          '#ac92eb'
        ]
        // set seat
        let list = []
        for (let i = 0; i < places.length; i++) {
          const place = places[i]
          const seats = place.seat.map(x => x)
          for (let j = 0; j < seats.length; j++) {
            const seat = seats[j]
            const seatMapInfo = seatMap ? seatMap.find(x => (x.placeId === place.placeId) && (x.seatId === seat.seatId)) : null
            seat.placeId = place.placeId
            seat.placeName = place.name
            seat.disabled = place.disabled
            seat.color = colors[i % colors.length]
            /**
             * 실제로 w, h, x, y 값만 seats 데이터에서 필요로 함
             * 나머지는 section.place와 매핑하여
             * 실시간 반영 해야함
             * 여기서 굳이 매핑한 이유는 display 때문
             */
            seat.w = seatMapInfo ? seatMapInfo.w : w
            seat.h = seatMapInfo ? seatMapInfo.h : h
            list.push(seat)
          }
        }
        list = list.map((x, i) => {
          const seatItem = seatMap ? seatMap.find(s => s.placeId === x.placeId && s.seatId === x.seatId) : null
          return {
            ...x,
            x: seatItem ? seatItem.x : getPositionX(i, listWidth, w, h),
            y: seatItem ? seatItem.y : getPositionY(i, listWidth, w, h)
          }
        })
        return list
      }
      this.info = null
      this.$store.commit('loading', true)
      this.$store.dispatch('reservation/getReservationPropertyInfo', reservationId).then((res) => {
        if (res) {
          this.track(res.space)
          this.info = {
            ...res,
            section: res.section.map(x => {
              return {
                ...x,
                seatMap: seatMapInit(x, x.seatMap)
              }
            }),
            time: getTime(res.time)
          }
        } else {
          const ln = this.$router.currentRoute.params.ln
          alert(this.locale.not_found_reservation)
          this.$router.replace({ path: `/${ln}` })
        }
        this.$store.commit('loading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noReservationData {
  padding-top: 30px;
  text-align: center;
  font-size: 1.2em;
}
.loadPage {
  margin-bottom: 30px;
  border-bottom: 1px solid $color-lgrey2;
}
</style>
